'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getAllPermissions() {
    const data = {
      method: 'get',
      url: 'permissions',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },

  async getUserPermissions(userId) {
    const data = {
      method: 'get',
      url: `users/${userId}/permissions`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },

  async updateUserPermissions(json) {
    const data = {
      method: 'post',
      url: 'update-permissions',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Permissions updated successfully')
      return response.data
    }
  },

  async getAllRoles() {
    const data = {
      method: 'get',
      url: 'roles',
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
}
